import $ from 'jquery';
import { h, render } from 'preact';
import { CartDrawerIO } from './io';
import { init as initProgress } from './cart-progress-show';
import { init as initProgressDrawer } from './cart-progress-bar-drawer';
import { App } from './app';
import { SALE_DEFAULTS } from '../../core/typescript/sale';
initProgress();
initProgressDrawer();
export const init = async function(machine) {
    const container = $('#js-cart-drawer');
    if (container.length === 0) {
        throw new Error('Cart drawer container element is missing [5c20cd67c23b4b9cabc32faaaafad3b6]');
    }
    const rawIo = container.find('script[type="application/json"]').first().text() || '{}';
    const { moneyFormat , giftBoxesDescriptions , giftBoxesTooltipTitle , sale  } = CartDrawerIO.create(JSON.parse(rawIo));
    const target = container.get(0);
    if (!target) {
        throw new Error('Cart drawer container element is missing [ff8f3209b45f4845acdd8d79f5f1cada]');
    }
    render(h(App, {
        machine,
        moneyFormat,
        giftBoxesTooltipTitle,
        giftBoxesDescriptions,
        sale: sale !== null && sale !== void 0 ? sale : SALE_DEFAULTS
    }), target);
};
